import React from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import { ErrorBoundary } from 'react-error-boundary';
import { isMobile } from 'react-device-detect';

import { BroadcasterPromo } from './broadcaster-promo/BroadcasterPromo';

import { navSelector } from 'store/modules/competition-nav/selectors/nav-selector';
import { getTranslation } from 'common/react/utils/translations';

import { FixturesDateHeader } from './FixturesDateHeader';
import { FixturesRoundHeader } from './FixturesRoundHeader';
import { Fixture } from './Fixture';

const { PROVIDER_IDS } = PULSE.app.common.CONSTANTS;
const AUS_TIMEZONE = 'australia';

const broadcasterRegion = () => {
    const timezone = moment.tz.guess(true);
    if (timezone.toLowerCase().split('/')[0] === AUS_TIMEZONE) {
        return true;
    }
    return false;
};

const DIGIT_ONLY_REGEX = /^[0-9]*$/;

export const FixturesItem = ({
    item,
    broadcastGuideUrl,
    disableRounds,
    broadcasterPromo,
    firstLiveOrUpcomingFixture
}) => {
    const nav = useSelector(navSelector);
    const itemType =
        typeof item === 'string'
            ? item.match(DIGIT_ONLY_REGEX) || item === 'TBCPC'
                ? 'date'
                : 'round'
            : 'match';

    const reportLabel = PULSE.app.common.url.urlify(
        getTranslation('label.mc.reportTab')
    );

    const mcLink = [
        PROVIDER_IDS.PRE_SEASON,
        PROVIDER_IDS.PREMIERSHIP,
        PROVIDER_IDS.VFL_PREMIERSHIP,
        PROVIDER_IDS.VFL_WOMENS,
        PROVIDER_IDS.WAFL_PREMIERSHIP,
        PROVIDER_IDS.WOMENS,
        PROVIDER_IDS.SANFL_PREMIERSHIP
    ].includes(nav?.competition.providerId);

    switch (itemType) {
        case 'date':
            return <FixturesDateHeader dateKey={item} />;
        case 'round':
            return disableRounds ? (
                <FixturesRoundHeader roundLabel={item} />
            ) : null;
        default:
            return (
                <ErrorBoundary key={item.id} fallback={<></>}>
                    <Fixture
                        mcLink={mcLink}
                        regionIsAus={broadcasterRegion()}
                        match={item}
                        reportLabel={reportLabel}
                        broadcastGuideUrl={broadcastGuideUrl}
                    />

                    {broadcasterPromo &&
                        isMobile &&
                        item.id === firstLiveOrUpcomingFixture && (
                            <BroadcasterPromo promo={broadcasterPromo} />
                        )}
                </ErrorBoundary>
            );
    }
};

FixturesItem.propTypes = {
    item: PropTypes.oneOfType([PropTypes.string, PropTypes.object]).isRequired,
    broadcastGuideUrl: PropTypes.string,
    round: PropTypes.object,
    disableRounds: PropTypes.bool,
    broadcasterPromo: PropTypes.object,
    firstLiveOrUpcomingFixture: PropTypes.number
};
